import { answerRepository } from "../repository/AnswerRepository";
import { ProfilerAnswers } from "../stores/useProfilerStore";
import { ScoreMaps } from "../types/BeautyProfilerResults";
import { BeautyProfilerAllureId } from "../types/BeautyProfilerAllure";
import { ProfilerProductId } from "../types/ProfilerProduct";

export const computeScores = (answers: ProfilerAnswers): ScoreMaps => {
  const allureScores = new Map<BeautyProfilerAllureId, number>();
  const productScores = new Map<ProfilerProductId, number>();

  for (const [questionId, answerId] of Array.from(answers.entries())) {
    try {
      const answerOption = answerRepository.getAnswerById(answerId);
      processAnswerOption(answerOption, allureScores, productScores);
    } catch (error) {
      console.error(
        `Failed to process answer ${answerId} for question ${questionId}:`,
        error
      );
    }
  }
  console.log("score computed", allureScores, productScores);
  return { allureScores, productScores };
};

const processAnswerOption = (
  answerOption: any,
  allureScores: Map<BeautyProfilerAllureId, number>,
  productScores: Map<ProfilerProductId, number>
): void => {
  if (answerOption.beautyProfilerAllure) {
    incrementScore(allureScores, answerOption.beautyProfilerAllure);
  }

  if (answerOption.beautyProfilerProducts && Array.isArray(answerOption.beautyProfilerProducts)) {
    for (const productId of answerOption.beautyProfilerProducts) {
      incrementScore(productScores, productId);
    }
  }
};

const incrementScore = <T>(scoreMap: Map<T, number>, key: T): void => {
  const currentCount = scoreMap.get(key) || 0;
  scoreMap.set(key, currentCount + 1);
}; 